import { useCallback, useMemo } from 'react';
import { captureException } from '../utils/sentryUtils';
import { useGetApprovalSkipConfigurationQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from '../constants/approvalTypeIds';
export const useApprovalSkipConfig = (approvalAction, approvalType) => {
  const {
    data: chirpData,
    loading: chirpLoading,
    refetch: chirpRefetch
  } = useGetApprovalSkipConfigurationQuery({
    variables: {
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction
    },
    // fetchPolicy 'network-only' ensures fresh data. If removing this need to test extensively
    fetchPolicy: 'network-only',
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalSkipConfig-chirp',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const skipConfig = useMemo(() => {
    if (!chirpData) return null;
    const {
      approvalSkipConfiguration: {
        skipApprovalOption,
        usersIdsListThatCanSkipApproval
      }
    } = chirpData;
    return {
      skipApprovalOption: skipApprovalOption,
      usersIdsListThatCanSkipApproval
    };
  }, [chirpData]);
  const fetchSkipConfig = useCallback(() => {
    void chirpRefetch();
  }, [chirpRefetch]);
  return useMemo(() => ({
    skipConfig,
    fetchSkipConfig,
    isLoading: chirpLoading
  }), [skipConfig, fetchSkipConfig, chirpLoading]);
};